// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wilI","col":"styles_col__3Xp2g"};